import { FunctionComponent } from "react";
import { Job } from "types/Job";
import { Project } from "types/Project";
import styles from "./cardContent.module.scss";

const JobContent: FunctionComponent<{
  dataType: Job | Project;
  expanded: boolean;
}> = ({ dataType, expanded }) => {
  const getFullExperienceTitle = (dataType: Job | Project) => {
    return dataType.company + " / " + dataType.type + " - " + dataType.title;
  };

  if (expanded) {
    return (
      <div className={`${styles.logo} ${expanded ? styles.expanded : ""}`}>
        {dataType.logo ? (
          <img
            src={dataType.logo}
            alt={`${dataType.company} logo`}
            width={150}
            height={150}
          />
        ) : (
          <h1>{dataType.company.toUpperCase()}</h1>
        )}
      </div>
    );
  }

  return (
    <div className={styles.textContainer}>
      <div className={styles.topContent}>
        {dataType.logo && (
          <div className={styles.logo}>
            <img src={dataType.logo} alt={`${dataType.company} logo`} />
          </div>
        )}
        <p className={styles.jobTitle}>{getFullExperienceTitle(dataType)}</p>
      </div>
      <div className={styles.jobSummary}>
        {dataType.summary.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>

      <div className={styles.hash_container}>
        {dataType.hashtags?.map((tag, tagIndex) => (
          <p className={styles.hash_tags} key={tagIndex}>
            {tag}
          </p>
        ))}
      </div>
    </div>
  );
};

export default JobContent;
